import React from 'react';

import { getProgressState } from './helpers';
import { LabelStyled, ProgressBarStyled, RootStyled } from './styles';
import { ProgressBarProps } from './types';

export const ProgressBar = ({
  animated,
  animationStartPercentage = 0,
  showLabel,
  roundedBar = true,
  roundedTrack = true,
  className,
  size = 'sm',
  color = 'primary',
  ...restProps
}: ProgressBarProps): JSX.Element => {
  const { percentage, labelValue } = getProgressState(restProps);

  return (
    <RootStyled className={className}>
      <ProgressBarStyled
        percentage={percentage}
        animated={animated}
        roundedBar={roundedBar}
        roundedTrack={roundedTrack}
        animationStartPercentage={animationStartPercentage}
        size={size}
        color={color}
      />
      {showLabel && <LabelStyled>{labelValue}</LabelStyled>}
    </RootStyled>
  );
};
